import { stats } from "@formant/core/common/stats";
import { duration } from "@formant/core/model/duration";

const sessionStart = performance.now();

export function logStats() {
    setInterval(() => {
        logMemoryUsage();
        logSessionDuration();
    }, duration.minute);
}

function logMemoryUsage() {
    const memory = () => (window.performance as any)?.memory;
    const { usedJSHeapSize, totalJSHeapSize, jsHeapSizeLimit } = memory() || {};
    if (usedJSHeapSize) {
        stats.aggregate("usedJSHeapSize", memory().usedJSHeapSize);
    }
    if (totalJSHeapSize) {
        stats.aggregate("totalJSHeapSize", memory().totalJSHeapSize);
    }
    if (jsHeapSizeLimit) {
        stats.aggregate("jsHeapSizeLimit", memory().jsHeapSizeLimit);
    }
}

function logSessionDuration() {
    stats.aggregate(
        "session_duration",
        Math.floor(performance.now() - sessionStart),
    );
}
